import { render, staticRenderFns } from "./Viewer.vue?vue&type=template&id=b9fad0bc&"
import script from "./Viewer.vue?vue&type=script&lang=ts&"
export * from "./Viewer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("c:\\vNextBuildV3\\29\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('b9fad0bc', component.options)
    } else {
      api.reload('b9fad0bc', component.options)
    }
    module.hot.accept("./Viewer.vue?vue&type=template&id=b9fad0bc&", function () {
      api.rerender('b9fad0bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "VueApp/common/components/MdEditor/Viewer.vue"
export default component.exports